import { css } from '@emotion/react'
import { CertificationUserTestQuestionType } from '@types'
import { Loader } from '@components/utils'

import CertificationTable from './CertificationTable'
import Header from './Header'

export type CertificationPropsType = {
  questionsRespondentFiltered: CertificationUserTestQuestionType[]
  isLoading?: boolean
}
const Certification = ({ questionsRespondentFiltered, isLoading }: CertificationPropsType) => {
  return (
    <div>
      <Header data={{}} />
      <div
        css={css`
          margin-top: 16px;
        `}
      >
        {isLoading && <Loader />}
        {!isLoading && (
          <CertificationTable questionsRespondentFiltered={questionsRespondentFiltered} />
        )}
      </div>
    </div>
  )
}

export default Certification
